module.exports = __webpack_public_path__ + "img/done.8800ef34.png";